import styles from "./style.module.css";
import logo from "../../assets/images/sideLogo.png";
import { useEffect, useMemo, useState } from "react";
import { TMTable } from "..";

export const ResultPrintOut = ({ resultData, date, level }) => {
	const [data, setData] = useState([]);

	function sliceIntoChunks(arr, chunkSize) {
		const res = [];
		for (let i = 0; i < arr?.length; i += chunkSize) {
			res.push(arr.slice(i, i + chunkSize));
		}
		return res;
	}

	useEffect(() => {
		setData(sliceIntoChunks(resultData?.studentGrades, 30));
	}, [resultData]);

	const gradeRange = {
		A: "70-100%",
		B: "60-69%",
		C: "50-59%",
		D: "45-49%",
		E: "40-44%",
		F: "0-39%"
	};

	const columns = useMemo(
		() => [
			{ Header: "S/N", accessor: "sn" },
			{ Header: "Name", accessor: "fullName" },

			{ Header: "Reg number", accessor: "matricNumber" },
			{
				Header: "Sex",
				accessor: "gender"
			},
			{ Header: "Quiz (20%)", accessor: "quiz" },
			{ Header: "Course Work (20%)", accessor: "courseWork" },
			{ Header: "Exam (60%)", accessor: "exam" },
			{ Header: "Total (100%)", accessor: "total" },
			{ Header: "Grade", accessor: "grade" },
			{ Header: "Remarks", accessor: "remarks" }
		],
		[]
	);

	const gradesColumn = useMemo(
		() => [
			{
				Header: "Range",
				Cell: ({ row }) => <div>{gradeRange[row.original.grade]}</div>
			},
			{ Header: "Grade", accessor: "grade" },
			{ Header: "Male", accessor: "male" },
			{ Header: "Female", accessor: "female" },
			{ Header: "Total", accessor: "total" }
		],
		//eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	const ALL_GRADES = ["A", "B", "C", "D", "E", "F"];

	const normalizedGradeGenderSummary = useMemo(() => {
		const summary = resultData?.gradeGenderSummary ?? [];

		return ALL_GRADES.map((grade) => {
			const found = summary.find((item) => item.grade === grade);

			return {
				grade,
				male: found?.male ?? "-",
				female: found?.female ?? "-",
				total: found?.total ?? "-"
			};
		});
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resultData]);

	return (
		<>
			{data.map((pageData, i) => (
				<section key={i} className={styles.section_container}>
					<div className={styles.img_container}>
						<img src={logo} alt="school logo" />
					</div>
					<h2
						className={styles.result_desc}
					>{`Department of ${resultData?.department} Score Sheet ${resultData?.semester} Semester`}</h2>

					<header className={styles.header_container}>
						<div>
							<div className={styles.student_details_grid}>
								<div>Course code:</div>
								<div>{resultData?.courseCode}</div>
							</div>
							<div className={styles.student_details_grid}>
								<div>Course title:</div>
								<div>{resultData?.courseTitle}</div>
							</div>
						</div>

						<div>
							<div className={styles.student_details_grid}>
								<div>Session:</div>
								<div>{resultData?.session}</div>
							</div>
							<div className={styles.student_details_grid}>
								<div>Level:</div>
								<div>{level ?? ""}</div>
							</div>
						</div>

						<div>
							<div className={styles.student_details_grid}>
								<div>Total Credit:</div>
								<div>{resultData?.courseUnit}Cr</div>
							</div>
							<div className={styles.student_details_grid}>
								<div>Date:</div>
								<div>{date}</div>
							</div>
						</div>
					</header>

					<TMTable columns={columns} data={pageData} />

					<footer className={styles.footer_container}>
						<div className={styles.footer_column}>
							<div className={styles.lecturer_details_grid}>
								<div>INTERNAL EXAMINER (NAME/SIGN):</div>
								<div className={styles.signature_line}>
									.............................................
								</div>
							</div>

							<div className={styles.lecturer_details_grid}>
								<div>HEAD OF DEPARTMENT (NAME/SIGN):</div>
								<div className={styles.signature_line}>
									.............................................
								</div>
							</div>

							<div className={styles.lecturer_details_grid}>
								<div>EXTERNAL EXAMINER (NAME/SIGN):</div>
								<div className={styles.signature_line}>
									.............................................
								</div>
							</div>
						</div>

						<div className={styles.footer_column}>
							<div className={styles.lecturer_details_grid}>
								<div>Date</div>
								<div className={styles.signature_line}>
									.............................................
								</div>
							</div>

							<div className={styles.lecturer_details_grid}>
								<div>Date</div>
								<div className={styles.signature_line}>
									.............................................
								</div>
							</div>

							<div className={styles.lecturer_details_grid}>
								<div>Date</div>
								<div className={styles.signature_line}>
									.............................................
								</div>
							</div>
						</div>
					</footer>

					<TMTable
						columns={gradesColumn}
						data={normalizedGradeGenderSummary}
					/>
				</section>
			))}
		</>
	);
};
